import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyALcLjTyssYHwdn-dsE_Iluepmc57MvBFY",
  authDomain: "millionmilesmay.firebaseapp.com",
  projectId: "millionmilesmay",
  storageBucket: "millionmilesmay.firebasestorage.app",
  messagingSenderId: "928198710096",
  appId: "1:928198710096:web:0f77585caa82c567015255",
  measurementId: "G-XGZ9V59Q4D"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const analytics = getAnalytics(app);

export { app, auth, db, functions, analytics }; 